import { BasicContactForm } from '../basicContactForm/basicContactForm';
import { BasicMap } from '../basicGoogleMap/basicGoogleMap';
import './less/footer.less';

const Footer = function(){
   const contactForm = new BasicContactForm();
   const basicMap = new BasicMap({
       isPredefined : true
   });
   
};

const footer = new Footer();

export { footer };


// WEBPACK FOOTER //
// ./components/footer/footer.js